import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface StatGridBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

interface StatItem {
  value: string;
  label: string;
}

const StatGridBlockRenderer: React.FC<StatGridBlockRendererProps> = ({ block, config }) => {
  const s = block.settings;
  const rawItems = s.items;
  const items: StatItem[] = Array.isArray(rawItems)
    ? rawItems
        .map((it) => {
          if (!it || typeof it !== 'object') return null;
          const o = it as Record<string, any>;
          return {
            value: String(o.value ?? ''),
            label: String(o.label ?? ''),
          };
        })
        .filter((x): x is StatItem => x !== null)
    : [];
  const colsRaw = s.columns;
  const columns =
    colsRaw === 2 || colsRaw === 3 || colsRaw === 4 ? colsRaw : 3;
  const accent =
    typeof s.accentColor === 'string' ? s.accentColor : config.aksanRenk;
  const labelSize = Math.max(10, Math.round(config.fontBoyutu * 0.85));
  const valueSize = Math.max(14, Math.round(config.fontBoyutu * 1.35));

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
        gap: 12,
        fontFamily: config.font,
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            border: `1px solid ${accent}33`,
            borderRadius: 8,
            padding: '14px 12px',
            textAlign: 'center',
            backgroundColor: '#ffffff',
          }}
        >
          <div
            style={{
              fontSize: valueSize,
              fontWeight: 700,
              color: config.anaRenk,
              lineHeight: 1.2,
              marginBottom: 6,
            }}
          >
            {item.value}
          </div>
          <div
            style={{
              fontSize: labelSize,
              fontWeight: 500,
              color: accent,
              lineHeight: 1.3,
            }}
          >
            {item.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatGridBlockRenderer;
